import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import toastr from "toastr";

const ReturnOrderDetails = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [productData, setProductData] = useState([]);
  const [returnList, setReturnList] = useState([]);
  const [showAllClaims, setShowAllClaims] = useState(false);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchData();
    }
    getAllReturns();
  }, [fromDate, toDate]);

  async function getAllReturns() {
    try {
      const response = await axios.get(
        `http://api.meddaily.in/get_all_return`,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (response.status === 200) {
        setReturnList(response?.data?.data);
        setShowAllClaims(true);
      }
    } catch (err) {
      toastr.error(err?.response?.data?.message);
      console.log(err);
    }
  }

  const fetchData = async () => {
    try {
      const url = "http://api.meddaily.in/get_all_return";
      const params = {
        from: fromDate,
        to: toDate,
      };
      const headers = {
        token: localStorage.getItem("disToken"),
      };

      const response = await axios.get(url, { params, headers });

      if (response.status === 200) {
        setProductData(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const sectionStyle = {
    marginTop: "5px",
    fontFamily: "Arial, sans-serif",
  };

  const tableStyle = {
    marginTop: "3px",
    fontFamily: "Arial, sans-serif",
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />

          <div className="layout-page">
            <Navbar />

            <div className="card">
              <div className="content-wrapper">
                <div className="container-xxl flex-grow-1 container-p-y">
                  <h3 className="card-header" style={{ sectionStyle }}>
                    Return Table
                  </h3>

                  <div className="row">
                    <div className="form-group col-md-6">
                      <label htmlFor="fromDate">From Date:</label>
                      <input
                        type="date"
                        id="fromDate"
                        className="form-control"
                        value={fromDate}
                        onChange={handleFromDateChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="toDate">To Date:</label>
                      <input
                        type="date"
                        id="toDate"
                        className="form-control"
                        value={toDate}
                        onChange={handleToDateChange}
                      />
                    </div>
                  </div>
                  <div style={sectionStyle} className="mt-5">
                    <h3 style={{ textAlign: "start" }}>Recent Return Claims</h3>
                    <div>
                      <table style={tableStyle} className="table mt-3">
                        <thead className="table-responsive text-nowrap">
                          <tr>
                            <th>ORDER ID</th>
                            <th>DISTRIBUTOR NAME</th>
                            <th>RETAILER NAME</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {returnList &&
                            returnList.length > 0 &&
                            returnList.map((product, ind) => (
                              <tr key={ind}>
                                <td>{product?.order_id}</td>
                                <td>{product?.distributor_name}</td>
                                <td>{product?.retailer_name}</td>
                                <td>
                                  <Link
                                    to={{
                                      pathname: "/orderdetails",
                                      state: { id: product?.order_id },
                                    }}
                                    className="dropdown-item"
                                  >
                                    View Full Details
                                  </Link>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div style={sectionStyle} className="mt-5">
                    <h3 style={{ textAlign: "start" }}>All Return Claims</h3>
                    {fromDate && toDate && showAllClaims ? (
                      <table style={tableStyle} className="table mt-3">
                        <thead className="table-responsive text-nowrap">
                          <tr>
                            <th>Order ID</th>
                            <th>Distributor Name</th>
                            <th>Retailer Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productData &&
                            productData.length > 0 &&
                            productData.map((product, ind) => (
                              <tr key={ind}>
                                <td>{product?.order_id}</td>
                                <td>{product?.distributor_name}</td>
                                <td>{product?.retailer_name}</td>
                                <td>
                                  <Link
                                    to={{
                                      pathname: "/orderdetails",
                                      state: { id: product?.order_id },
                                    }}
                                    className="dropdown-item"
                                  >
                                    View Full Details
                                  </Link>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnOrderDetails;
